import { addClass } from '../add-class';
import { removeClass } from '../remove-class';

export function changeClass(element: Element, className: string, add = true) {
	if (add) {
		addClass(element, className);
	} else {
		removeClass(element, className);
	}
}
